import React from "react";

function Summary({ character, saveCharacter }) {
  if (!character) return <div>Caricamento...</div>;

  const {
    playerName,
    characterInfo,
    characteristics,
    points,
    skills,
    weapons,
    background,
    cash,
  } = character;

  // Get only skills with value > minValue
  const activeSkills =
    skills?.filter((skill) => skill.value > skill.minValue) || [];

  return (
    <div className="character-step-summary">
      <h2>Riepilogo Personaggio</h2>

      {/* Header con Avatar e Info Base */}
      <div className="summary-header">
        {character.images?.avatar && (
          <div className="summary-avatar">
            <img src={character.images.avatar} alt="Avatar" />
          </div>
        )}
        <div className="summary-basic-info">
          <div className="summary-info-row">
            <span className="label">Giocatore:</span>
            <span className="value">{playerName || "Non specificato"}</span>
          </div>
          <div className="summary-info-row">
            <span className="label">Personaggio:</span>
            <span className="value">
              {characterInfo?.name || "Non specificato"}
            </span>
          </div>
          <div className="summary-info-row">
            <span className="label">Occupazione:</span>
            <span className="value">
              {characterInfo?.work || "Non specificata"}
            </span>
          </div>
          <div className="summary-info-grid">
            <div>
              <span className="label">Età:</span>
              <span className="value">{characterInfo?.age || "-"}</span>
            </div>
            <div>
              <span className="label">Sesso:</span>
              <span className="value">{characterInfo?.sex || "-"}</span>
            </div>
            <div>
              <span className="label">Residenza:</span>
              <span className="value">{characterInfo?.residence || "-"}</span>
            </div>
            <div>
              <span className="label">Anno di Nascita:</span>
              <span className="value">{characterInfo?.bornage || "-"}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Caratteristiche */}
      <div className="summary-section">
        <h3>Caratteristiche</h3>
        <div className="summary-characteristics">
          {characteristics?.map((char, index) => (
            <div key={index} className="summary-stat">
              <span className="stat-name">{char.name}</span>
              <span className="stat-value">{char.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Attributi Derivati */}
      <div className="summary-section">
        <h3>Attributi Derivati</h3>
        <div className="summary-points">
          {points?.map((point, index) => (
            <div key={index} className="summary-stat">
              <span className="stat-name">{point.name}</span>
              <span className="stat-value">
                {point.maxValue
                  ? `${point.value}/${point.maxValue}`
                  : point.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Abilità Principali */}
      {activeSkills.length > 0 && (
        <div className="summary-section">
          <h3>Abilità Sviluppate ({activeSkills.length})</h3>
          <div className="summary-skills">
            {activeSkills
              .sort((a, b) => b.value - a.value)
              .slice(0, 15)
              .map((skill, index) => (
                <div key={index} className="summary-skill">
                  <span className="skill-name">{skill.name}</span>
                  <span className="skill-value">{skill.value}%</span>
                </div>
              ))}
            {activeSkills.length > 15 && (
              <div className="summary-skill-more">
                +{activeSkills.length - 15} altre abilità...
              </div>
            )}
          </div>
        </div>
      )}

      {/* Armi */}
      {weapons?.length > 0 && (
        <div className="summary-section">
          <h3>Armi</h3>
          <div className="summary-weapons">
            {weapons.map((weapon, index) => (
              <div key={index} className="summary-weapon">
                <span className="weapon-name">{weapon.name}</span>
                <div className="weapon-details">
                  <span>Danno: {weapon.damage}</span>
                  <span>Raggio: {weapon.range}</span>
                  <span>Skill: {weapon.value}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Background (se compilato) */}
      {background && Object.values(background).some((val) => val !== "") && (
        <div className="summary-section">
          <h3>Background</h3>
          <div className="summary-background">
            {background.description && (
              <div className="background-item">
                <strong>Descrizione:</strong> {background.description}
              </div>
            )}
            {background.ideology && (
              <div className="background-item">
                <strong>Ideologia/Credenze:</strong> {background.ideology}
              </div>
            )}
            {background.importantPeople && (
              <div className="background-item">
                <strong>Persone Importanti:</strong>{" "}
                {background.importantPeople}
              </div>
            )}
            {background.significantPlaces && (
              <div className="background-item">
                <strong>Luoghi Significativi:</strong>{" "}
                {background.significantPlaces}
              </div>
            )}
            {background.valuables && (
              <div className="background-item">
                <strong>Beni Preziosi:</strong> {background.valuables}
              </div>
            )}
            {background.traits && (
              <div className="background-item">
                <strong>Tratti:</strong> {background.traits}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Finanze */}
      {cash && (
        <div className="summary-section">
          <h3>Finanze</h3>
          <div className="summary-cash">
            <div className="cash-item">
              <span className="label">Livello di Spesa:</span>
              <span className="value">{cash.spendinglevel || 0}</span>
            </div>
            <div className="cash-item">
              <span className="label">Denaro:</span>
              <span className="value">{cash.cash || 0}</span>
            </div>
          </div>
        </div>
      )}

      {/* Pulsante Salvataggio */}
      <div className="summary-submit">
        <button onClick={() => saveCharacter()}>Crea Personaggio</button>
      </div>
    </div>
  );
}

export default Summary;
